import React from 'react';

import kebabCase from 'lodash/kebabCase';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconCheck } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import type { TaskShape } from '../../../../types';

type CompletedTaskProps = Pick<TaskShape, 'name' | 'title' | 'description'>;
export function CompletedTask({ name, title, description }: CompletedTaskProps): React.JSX.Element {
	return (
		<Box data-qa="petition-task">
			<Flex sx={{ gap: [16, 24] }}>
				<Flex
					sx={{
						alignItems: 'center',
						justifyContent: 'center',
						backgroundColor: 'secondary-green',
						borderRadius: 'full',
						height: 40,
						width: 40,
						flexShrink: 0,
					}}
				>
					<Icon icon={iconCheck} size={20} color="primary-white" />
				</Flex>
				<Flex
					sx={{
						flexDirection: ['column', 'row'],
						alignItems: ['flex-start', 'center'],
						justifyContent: [null, 'space-between'],
						gap: [16, 24],
						width: '100%',
					}}
				>
					<Flex sx={{ flexDirection: 'column', gap: 8 }}>
						<Heading data-qa={`task-title-${kebabCase(name)}`} as="h3" size="h5" color="typography-secondary">
							{title}
						</Heading>
						<Text as="p" data-qa={`task-description-${kebabCase(name)}`} color="typography-secondary">
							{description}
						</Text>
					</Flex>
				</Flex>
			</Flex>
		</Box>
	);
}
